import React, { useState, useContext } from 'react';
import { Button, DialogActions, Grid, TextField, CircularProgress, IconButton } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import PriceCategoryService from 'services/PriceCategoryService';
import { useTranslation } from 'react-i18next';

export default function PriceCategoryEditDialog({ priceCategory, handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');

  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState(priceCategory || {});

  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleActionButton = async () => {
    setLoading(true);
    try {
      const updatedCategory = await PriceCategoryService.updatePriceCategory(data.id, data);
      postAlertMessage({ text: tPopup('Price category updated successfully'), type: 'success' });
      handleSuccess(updatedCategory);
    } catch (error) {
      postAlertMessage({ text: error?.message, type: 'failed' });
      handleClose();
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Edit Price Category')}</h2>
            <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
          </div>
          <div className={styles.inputSec}>
            <div>
              <Grid container alignItems="center">
                <Grid item sm={4} xs={4}>
                  <h6 className={styles.tableName}>{tCommon('Category Name')}</h6>
                </Grid>
                <Grid item sm={8} xs={8}>
                  <TextField
                    label={tCommon('Category Name')}
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    defaultValue={data.name}
                    onChange={(e) => {
                      setData({ ...data, name: e.target.value });
                    }}
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <div className={styles.footSec}>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name || isLoading}
                onClick={handleActionButton}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" sx={{ mr: 1.25 }} />
                    {tCommon('Updating...')}
                  </>
                ) : (
                  tCommon('Update')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
